import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'components';
import './styles.scss';

const CrudAlertField = ({ onClick, ...rest }) => {
    const classNames = ['crud-alert-field'];
    if (onClick) {
        classNames.push('crud-alert-field__clickable');
    }
    return (
        <div role="button" tabIndex="-1" onClick={onClick} className={classNames.join(' ')}>
            <Alert {...rest} />
        </div>
    );
};

CrudAlertField.propTypes = {
    onClick: PropTypes.func,
};

export default CrudAlertField;
